import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnTipMedia extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public type: string;

  @Expose()
  public url: string;

  constructor(data: any) {
    super();

    this.fromJSON(data);
  }
}
